// Письма о пунктах в ритме планёрки (031: contracts/api.md, «Письма»; FR-022 – FR-035;
// ASG-NTF-02 – ASG-NTF-12, ASG-NTF-18; ADR-0046). Письмо собирается из непрочитанных уведомлений
// человека; одно письмо в сутки; вариант — по каналу (извещение без ФИО и текста пунктов).
import { z } from '../kernel/zod.ts';
import { ShadowStatusSchema } from './message.ts';
import { IdSchema, TimestampSchema } from '../kernel/common.ts';

/** Виды писем ритма планёрки (без копии куратору). */
export const itemLetterKinds = ['meeting_results', 'meeting_tomorrow', 'morning'] as const;
export type ItemLetterKind = (typeof itemLetterKinds)[number];
export const ItemLetterKindSchema = z.enum(itemLetterKinds);

export const itemLetterKindLabels = {
  meeting_results: 'Итоги планёрки',
  meeting_tomorrow: 'Завтра планёрка',
  morning: 'Утреннее письмо',
} as const satisfies Record<ItemLetterKind, string>;

/** Письмо-тень протокола в окне готовности (FR-018): кому, вид, что в письме. */
export const ShadowLetterSchema = z.object({
  id: IdSchema,
  kind: ItemLetterKindSchema,
  /** ФИО записи человека или «Ведущий» — без адреса. */
  recipient: z.string(),
  subject: z.string(),
  /** Текстовая часть письма, как собрана. */
  text: z.string(),
  createdAt: TimestampSchema,
  /** 0.26.1 (ACC-07): причины тени, что действует сейчас, где исправить. */
  shadow: ShadowStatusSchema.optional(),
});
export type ShadowLetter = z.infer<typeof ShadowLetterSchema>;

/** GET /api/protocols/{id}/shadow-letters. */
export const ShadowLettersSchema = z.object({ items: z.array(ShadowLetterSchema) });

/** Пакетный ввод почты (FR-013): 1–50 строк «человек — адрес». */
export const SetEmailsBodySchema = z.strictObject({
  items: z
    .array(z.strictObject({ personId: IdSchema, address: z.string().trim().min(3).max(254) }))
    .min(1)
    .max(50),
});
export type SetEmailsBody = z.infer<typeof SetEmailsBodySchema>;

export const SetEmailsResultSchema = z.object({
  saved: z.number().int().min(0),
  failed: z.array(z.object({ personId: IdSchema, code: z.string() })),
});
export type SetEmailsResult = z.infer<typeof SetEmailsResultSchema>;

/** POST /api/auth/time-zone: пояс браузера (IANA), один раз (FR-028). */
export const TimeZoneBodySchema = z.strictObject({ timeZone: z.string().min(1).max(64) });
